module.exports = __webpack_public_path__ + "static/img/sanwei2.b0880164.png";